
import { renderHTML } from '@app/vue/Utils/editorjs-viewer';
import SwiperBigGalleryWidget from '@app/modules/widget/swiper/big-gallery';
import SwiperCarouselFixHeightWidget from '@app/modules/widget/swiper/carousel-fix-height';

export default {
    props: {
        element: {
            type: Object,
        },
    },
    methods: {
        render(value) {
            if (!value) {
                return;
            }
            try {
                const data = JSON.parse(value);
                return renderHTML(data.blocks);
            } catch (err) {
                console.warn(err);
                return '';
            }
        },
    },
    mounted() {
        this.$nextTick(function () {
            new SwiperBigGalleryWidget().init();
            new SwiperCarouselFixHeightWidget().init();
        });
    },
};
